const CompanyActionTypes = {
	/*************** Create Company Start ******************/
	ADD_COMPANY_DETAILS_START: 'add_company_details_start',
	ADD_COMPANY_DETAILS_SUCCESS: 'add_company_details_success',
	ADD_COMPANY_DETAILS_FAILURE: 'add_company_details_failure',
	ADD_COMPANY_DETAILS_RESPONSE_RESET: 'add_company_details_response_reset',
	ADD_COMPANY_DETAILS_RESPONSE_CHANGED: 'add_company_details_response_changed',
	/*************** Create Company End ******************/

	/*************** Get All Company List Start ******************/
	GET_COMPANY_LIST_START: 'get_company_list_start',
	GET_COMPANY_LIST_SUCCESS: 'get_company_list_success',
	GET_COMPANY_LIST_FAILURE: 'get_company_list_failure',
	GET_COMPANY_LIST_RESPONSE_RESET: 'get_company_list_response_reset',
	GET_COMPANY_LIST_RESPONSE_CHANGED: 'get_company_list_response_changed',
	/*************** Get All Company List ENd ******************/

	/*************** Fetch Company Details Start ******************/
	FETCH_COMPANY_DETAILS_START: 'fetch_company_details_start',
	FETCH_COMPANY_DETAILS_SUCCESS: 'fetch_company_details_success',
	FETCH_COMPANY_DETAILS_FAILURE: 'fetch_company_details_failure',
	FETCH_COMPANY_DETAILS_RESPONSE_RESET: 'fetch_company_details_response_reset',
	FETCH_COMPANY_DETAILS_RESPONSE_CHANGED: 'fetch_company_details_response_changed',
	/*************** Fetch Company Details End ******************/

	/*************** Update Company Details Start ******************/
	UPDATE_COMPANY_DETAILS_START: 'update_company_details_start',
	UPDATE_COMPANY_DETAILS_SUCCESS: 'update_company_details_success',
	UPDATE_COMPANY_DETAILS_FAILURE: 'update_company_details_failure',
	UPDATE_COMPANY_DETAILS_RESPONSE_RESET: 'update_company_details_response_reset',
	UPDATE_COMPANY_DETAILS_RESPONSE_CHANGED: 'update_company_details_response_changed',
	/*************** Update Company Details End ******************/

	/*************** Delete Company Details Start ******************/
	DELETE_COMPANY_DETAILS_START: 'delete_company_details_start',
	DELETE_COMPANY_DETAILS_SUCCESS: 'delete_company_details_success',
	DELETE_COMPANY_DETAILS_FAILURE: 'delete_company_details_failure',
	DELETE_COMPANY_DETAILS_RESPONSE_RESET: 'delete_company_details_response_reset',
	DELETE_COMPANY_DETAILS_RESPONSE_CHANGED: 'delete_company_details_response_changed',
	/*************** Delete Company Details End ******************/

	/*************** Create Company For Finance Start ******************/
	CREATE_COMPANY_START: 'create_company_start',
	CREATE_COMPANY_SUCCESS: 'create_company_success',
	CREATE_COMPANY_FAILURE: 'create_company_failure',
	CREATE_COMPANY_RESPONSE_RESET: 'create_company_response_reset',
	CREATE_COMPANY_RESPONSE_CHANGED: 'create_company_response_changed',
	/*************** Create Company For Finance End ******************/

	/*************** Update Company For Finance Start ******************/
	UPDATE_COMPANY_START: 'update_company_start',
	UPDATE_COMPANY_SUCCESS: 'update_company_success',
	UPDATE_COMPANY_FAILURE: 'update_company_failure',
	UPDATE_COMPANY_RESPONSE_RESET: 'update_company_response_reset',
	UPDATE_COMPANY_RESPONSE_CHANGED: 'update_company_response_changed',
	/*************** Update Company For Finance End ******************/

	/*************** Delete Company For Finance End ******************/
	DELETE_COMPANY_START: 'delete_company_start',
	DELETE_COMPANY_SUCCESS: 'delete_company_success',
	DELETE_COMPANY_FAILURE: 'delete_company_failure',
	DELETE_COMPANY_RESPONSE_RESET: 'delete_company_response_reset',
	DELETE_COMPANY_RESPONSE_CHANGED: 'delete_company_response_changed',
	/*************** Delete Company For Finance End ******************/

	/** ***************** ADD INSTANCE DETAILS START *********************** */
	ADD_INSTANCE_DETAILS_START: 'add_instance_details_start',
	ADD_INSTANCE_DETAILS_SUCCESS: 'add_instance_details_success',
	ADD_INSTANCE_DETAILS_FAILURE: 'add_instance_details_failure',
	ADD_INSTANCE_DETAILS_RESPONSE_RESET: 'add_instance_details_response_reset',
	ADD_INSTANCE_DETAILS_RESPONSE_CHANGED: 'add_instance_details_response_changed',
	/** ***************** ADD INSTANCE DETAILS END *********************** */

	/*** ADD ALTER TABLE START ***/
	ADD_ALTER_TABLE_START: 'add_alter_table_start',
	ADD_ALTER_TABLE_SUCCESS: 'add_alter_table_success',
	ADD_ALTER_TABLE_FAILURE: 'add_alter_table_failure',
	ADD_ALTER_TABLE_RESPONSE_RESET: 'add_alter_table_response_reset',
	ADD_ALTER_TABLE_RESPONSE_CHANGED: 'add_alter_table_response_changed',
	/***ADD ALTER TABLE  END ***/

	/*** FETCH EXIST DATA CHEK START ***/
	FETCH_EXIST_DATA_START: 'fetch_exist_data_start',
	FETCH_EXIST_DATA_SUCCESS: 'fetch_exist_data_success',
	FETCH_EXIST_DATA_FAILURE: 'fetch_exist_data_failure',
	FETCH_EXIST_DATA_RESPONSE_RESET: 'fetch_exist_data_reset',
	FETCH_EXIST_DATA_RESPONSE_CHANGED: 'fetch_exist_data_changed',
	/***FETCH EXIST DATA CHEK  END ***/
};

export default CompanyActionTypes;
